import React, {useContext, useState} from "react";
import styled from "styled-components";
import { Button, Image, Text } from "rebass";

import { AuthContext } from "../Contexts";
import { HR } from "./HR";
import {AddPatientModal} from "../Views/Patients/AddPatientModal";
import {ManageHeadsetsModal} from "../Views/ManageHeadsetsModal";
import {HelpModal} from "../Views/HelpModal";


export const SelectHeader = () => {
  const authContext = useContext(AuthContext);


  return (
    <div>
      <Container>
        <Image
          width="70%"
          display="block"
          marginLeft="auto"
          marginRight="auto"
          src="/vivid_vision_logo.png"
          alt="logo"
        />
      </Container>

      <HR />
    </div>
  );
};

export const OverviewHeader = () => {
  const authContext = useContext(AuthContext);

  const [headsetsIsOpen, setHeadsetsIsOpen] = useState(false);
  const [helpIsOpen, setHelpIsOpen] = useState(false);

  return (
    <>
      <div style={{background:"white"}}>
        <Button variant="textButton" onClick={() => setHelpIsOpen(true)} margin={2}>
          Help
        </Button>
        {/* <Button variant="textButton" onClick={() => setHeadsetsIsOpen(true)} margin={2}>
          Manage Headsets
        </Button> */}
        <Button variant="textButton" onClick={authContext.logOut} margin={2}>
          Log out
        </Button>
      </div>
      <ManageHeadsetsModal isOpen={headsetsIsOpen} setIsOpen={setHeadsetsIsOpen}/>
      <HelpModal isOpen={helpIsOpen} setIsOpen={setHelpIsOpen}/>
    </>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 13px;
`;
